import debounce from 'lodash.debounce';

const { dataLayer } = window;

export default {
  data() {
    return {
      query: ''
    };
  },
  methods: {
    doSearch: debounce(function doSearch() {
      if (!this.isValidQuery()) return;

      dataLayer.push({
        event: 'ExpertsSearch',
        query: this.query
      });
    }, 2000),
    isValidQuery() {
      return this.query !== '' && this.query.length >= 2;
    }
  }
};
